import React from 'react';

function Footer() {
  return (
    <div className="page-footer" id="footer">
      <a href="https://github.com/crisdege">
        <img
          src="https://img.icons8.com/ios/80/000000/github.png"
          alt="github-logo"
          class="icon"
        />
      </a>
      <a href="https://www.linkedin.com/in/cristina-dege-8665021a3/">
        <img
          src="https://img.icons8.com/fluent/80/000000/linkedin-circled.png"
          alt="linkedin-logo"
          class="icon"
        />
      </a>
      <a href="https://stackoverflow.com/users/19137333/crisdege">
        <img
          src="https://img.icons8.com/ios/80/000000/stackoverflow.png"
          alt="stack-overflow"
          class="icon"
        />
      </a>
    </div>
  );
}

export default Footer;
